import { render, staticRenderFns } from "./Register-test.vue?vue&type=template&id=00bce168&scoped=true&"
import script from "./Register-test.vue?vue&type=script&lang=js&"
export * from "./Register-test.vue?vue&type=script&lang=js&"
import style0 from "./Register-test.vue?vue&type=style&index=0&id=00bce168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bce168",
  null
  
)

export default component.exports